import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Register from "../pages/Register";
import Profile from "../pages/account/Profile";
import CategoryPage from "../pages/CategoryPage";
import ChangePassword from "../pages/account/ChangePassword";
import PrivateRoute from "../components/PrivateRoute";
import Rendezvous from "../pages/Rendezvous";
import ResultatRecherche from "../pages/ResultatRecherche";
import SingleRendezVous from "../pages/SingleRendezVous";
import { useLocation } from "react-router-dom";
import PaymentInfo from "../pages/account/PaymentInfo";
import SuccessRdv from "../pages/SuccessRdv";
import ReviewPage from "../pages/ReviewPage";
import ReviewSuccessPage from "../pages/ReviewSuccessPage";
import EditRendezvous from "../pages/EditRendezvous";
import SuccessEditRdv from "../pages/SuccessEditRdv";
import ChoiceFormula from "../pages/prestataires/ChoiceFormula";
import Confirmation from "../pages/prestataires/confirmation";
import RegisterPrestataire from "../pages/prestataires/RegisterPrestataire";
import PersonalInformations from "../pages/prestataires/PersonalInformations";
import BillingAddress from "../pages/prestataires/BillingAddress";
import EstablishmentInformations from "../pages/prestataires/infoEtablissement";
import SingleEtablissement from "../pages/etablissements/SingleEtablissement";
import StepOneReset from "../pages/resetPassword/stepOneReset";
import StepTwoReset from "../pages/resetPassword/stepTwoReset";
import NewPassword from "../pages/resetPassword/newPassword";
import Paiement from "../pages/prestataires/paiement";
import TypeActivity from "../pages/prestataires/typeActivity";
import Horaires from "../pages/prestataires/horaires";
import Photos from "../pages/prestataires/photos";
import Services from "../pages/prestataires/services";
import Equipe from "../pages/prestataires/equipe";
import ConfirmPage from "../pages/prestataires/confirmPage";
import FavorisPage from "../pages/account/FavorisPage";
import InfoPrestations from "../pages/reservation/infoPrestations";
import InfoPrestationsStepTwo from "../pages/reservation/infoPrestationsStepTwo";
import Cgv from "../pages/juridique/cgv";
import Cgu from "../pages/juridique/cgu";
import Pl from "../pages/juridique/pl";
import DemandeRemboursement from "../pages/account/DemandeRemboursement";
import SingleNonInscrit from "../pages/etablissements/singleNonInscrit";
import NotFoundRoute from "../pages/NotFound";
import Apropos from "../pages/juridique/Apropos";
import MentionsLegales from "../pages/juridique/MentionsLegales";
import AllFaq from "../pages/juridique/AllFaq";
import Identification from "../pages/reservation/identification";
import IdentificationRegister from "../pages/reservation/identificationRegister";
import Facturation from "../pages/reservation/facturation";
import IdentificationInvite from "../pages/auth/invite";
import PaymentForm from "../pages/reservation/payment";
import StripeWrapper from "../pages/reservation/stripeWrapper";
import CheckoutForm from "../pages/reservation/payment";
import ConfirmPageRendezVous from "../pages/reservation/confirrmPage";
import Accueil from "../pages/accountPrestataire/Accueil";
import Agenda from "../pages/accountPrestataire/Agenda";
import DemandeRdv from "../pages/accountPrestataire/DemandeRdv";
import RendezVousPresta from "../pages/accountPrestataire/RendezVousPresta";
import AvisClient from "../pages/accountPrestataire/AvisClient";

import PageEtablissement from "../pages/accountPrestataire/pageEtablissement";
import MonPlan from "../pages/accountPrestataire/monPlan";
import PaymentPlan from "../pages/accountPrestataire/paymentPlan";
import ListPayment from "../pages/accountPrestataire/listPayments";
import Blog from "../pages/Blog";
import LandingPage from "../pages/landingPage";
import SignleArticle from "../pages/SignleArticle";
import Illicite from "../pages/juridique/illicite";
import FraisDoc from "../pages/juridique/frais";


const RedirectAuthenticated = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const location = useLocation();
  return children;
};

const AppRoutes = () => {
  const routes = [
    { path: "/", element: <Home /> },
    { path: "/Espace-prestataire", element: <LandingPage /> },
    { path: "*", element: <NotFoundRoute /> },
    {
      path: "/login",
      element: (
        <RedirectAuthenticated>
          <Login />
        </RedirectAuthenticated>
      ),
    },
    {
      path: "/register",
      element: (
        <RedirectAuthenticated>
          <Register />
        </RedirectAuthenticated>
      ),
    },
    {
      path: "/mot-de-passe-oublie",
      element: (
        <RedirectAuthenticated>
          <StepOneReset />
        </RedirectAuthenticated>
      ),
    },
    {
      path: "/sendCode",
      element: (
        <RedirectAuthenticated>
          <StepTwoReset />
        </RedirectAuthenticated>
      ),
    },
    {
      path: "/nv-mot-de-passe",
      element: (
        <RedirectAuthenticated>
          <NewPassword />
        </RedirectAuthenticated>
      ),
    },
    {
      path: "/category",
      element: <CategoryPage />,
    },
    {
      path: "/resultats",
      element: <ResultatRecherche />,
    },
    {
      path: "/etablissement/:id",
      element: <SingleEtablissement />,
    },
    {
      path: "/etablissement-non-inscrit/:id/:slug",
      element: <SingleNonInscrit />,
    },

    { path: "/registerPrestataire", element: <RegisterPrestataire /> },
    { path: "/personalInformations", element: <PersonalInformations /> },
    { path: "/choiceFormula", element: <ChoiceFormula /> },
    { path: "/billingaddress", element: <BillingAddress /> },
    { path: "/confirmation/:id_session", element: <Confirmation /> },
    { path: "/confirmation", element: <Confirmation /> },
    { path: "/paiement", element: <Paiement /> },
    { path: "/establishmentInfo", element: <EstablishmentInformations /> },
    { path: "/type-activite", element: <TypeActivity /> },
    { path: "/ouverture", element: <Horaires /> },
    { path: "/photos", element: <Photos /> },
    { path: "/services", element: <Services /> },
    { path: "/equipe", element: <Equipe /> },
    { path: "/confirm", element: <ConfirmPage /> },
    { path: "/favoris", element: <FavorisPage /> },

    //fichiers juridique
    { path: "/cgv", element: <Cgv /> },
    { path: "/frais", element: <FraisDoc /> },
    { path: "/cgu", element: <Cgu /> },
    { path: "/politique-confidentialite", element: <Pl /> },
    { path: "/apropos", element: <Apropos /> },
    { path: "/mentions-legales", element: <MentionsLegales /> },
    { path: "/Politique-de-lutte-contre-les-contenus-illicites", element: <Illicite /> },
    { path: "/tous-faq", element: <AllFaq /> },
    { path: "/blog", element: <Blog /> },
    { path: "/articles/:id", element: <SignleArticle /> },
    //rdv
    { path: "/choisir-prestation/:id", element: <InfoPrestations /> },
    { path: "/details-rdv/:id", element: <InfoPrestationsStepTwo /> },
    { path: "/identification/:id", element: <Identification /> },
    { path: "/register-rdv/:id", element: <IdentificationRegister /> },
    { path: "/compte-invite/:id", element: <IdentificationInvite /> },
    { path: "payment/:id", element: <CheckoutForm /> },
    { path: "confirm-rendez-vous/:id", element: <ConfirmPageRendezVous /> },
    { path: "/facturation/:id", element: <Facturation /> },
  ];

  const privateRoutes = [
    //compte client
    { path: "/compte/informations-personnel", element: <Profile /> },
    { path: "/compte/changer-mot-de-passe", element: <ChangePassword /> },
    { path: "/compte/rendez-vous", element: <Rendezvous /> },
    { path: "/compte/informations-paiement", element: <PaymentInfo /> },
    { path: "/compte/favoris", element: <FavorisPage /> },
    {
      path: "/compte/demande-remboursement/:idRdv",
      element: <DemandeRemboursement />,
    },
    { path: "/compte/rendez-vous/success", element: <SuccessRdv /> },
    { path: "/compte/rendez-vous/:id", element: <SingleRendezVous /> },
    { path: "/compte/rendez-vous/edit/:id", element: <EditRendezvous /> },
    { path: "compte/rendez-vous/edited/success", element: <SuccessEditRdv /> },
    { path: "/compte/review/:id", element: <ReviewPage /> },
    { path: "compte/review/success", element: <ReviewSuccessPage /> },

    //compte prestataire
    { path: "compte/prestataire/accueil", element: <Accueil /> },
    { path: "compte/prestataire/agenda", element: <Agenda /> },
    { path: "compte/prestataire/demande-rendez-vous", element: <DemandeRdv /> },
    { path: "compte/prestataire/rendez-vous", element: <RendezVousPresta /> },
    { path: "compte/prestataire/avis-clients", element: <AvisClient /> },
    {
      path: "compte/prestataire/page-etablissement",
      element: <PageEtablissement />,
    },
    { path: "compte/prestataire/mon-plan", element: <MonPlan /> },
    { path: "compte/prestataire/mon-plan/paiement", element: <PaymentPlan /> },
    { path: "compte/prestataire/mes-paiements", element: <ListPayment /> },
  ].map((route) => ({
    ...route,
    element: <PrivateRoute>{route.element}</PrivateRoute>,
  }));

  return [...routes, ...privateRoutes];
};

export default AppRoutes;
